import React from 'react';

import { ConnectionStatus } from './types';

interface ConnectionStatusViewProps {
  status: ConnectionStatus;
  isLoading: boolean;
  onDisconnect: () => void;
  onChange: () => void;
  onSync: (direction: 'source_to_mirror' | 'mirror_to_source') => void;
  syncMessage?: string | null;
}

export const ConnectionStatusView: React.FC<ConnectionStatusViewProps> = ({
  status,
  isLoading,
  onDisconnect,
  onChange,
  onSync,
  syncMessage,
}) => (
  <div className="github-status-connected">
    <span>✓ Connected</span>
    <div>
      <strong>Source:</strong>{' '}
      <a
        href={status.source_repo_url || status.repo_url || '#'}
        target="_blank"
        rel="noopener noreferrer"
        className="github-repo-link"
      >
        {status.source_repo_url || status.repo_url}
      </a>
    </div>
    {status.mirror_repo_url && (
      <div>
        <strong>8080 mirror:</strong>{' '}
        <a
          href={status.mirror_repo_url}
          target="_blank"
          rel="noopener noreferrer"
          className="github-repo-link"
        >
          {status.mirror_repo_url}
        </a>
      </div>
    )}
    {status.default_branch && (
      <div>
        <strong>Default branch:</strong> {status.default_branch}
      </div>
    )}
    <div>
      <strong>User:</strong> {status.username}
    </div>
    <div className="github-sync-actions">
      <button
        type="button"
        className="btn-primary"
        onClick={() => onSync('source_to_mirror')}
        disabled={isLoading}
      >
        Sync GitHub → 8080
      </button>
      <button
        type="button"
        className="btn-secondary"
        onClick={() => onSync('mirror_to_source')}
        disabled={isLoading}
      >
        Sync 8080 → GitHub
      </button>
    </div>
    {syncMessage && <div className="github-sync-message">{syncMessage}</div>}
    <div className="github-status-actions">
      <button type="button" className="btn-secondary" onClick={onChange} disabled={isLoading}>
        Change repository
      </button>
      <button
        type="button"
        className="btn-danger"
        onClick={onDisconnect}
        disabled={isLoading}
      >
        {isLoading ? 'Working...' : 'Disconnect source'}
      </button>
    </div>
  </div>
);
